// File: src/components/VideoGenerationHistoryDialog.tsx

import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    CircularProgress,
    Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { VideoGeneration, Product } from '../../types';

interface VideoGenerationHistoryDialogProps {
    open: boolean;
    onClose: () => void;
    historyGenerations: VideoGeneration[];
    product?: Product;
    onLoadGeneration: (gen: VideoGeneration) => void;
    isLoading?: boolean;
}

const VideoGenerationHistoryDialog: React.FC<VideoGenerationHistoryDialogProps> = ({
                                                                                       open,
                                                                                       onClose,
                                                                                       historyGenerations,
                                                                                       product,
                                                                                       onLoadGeneration,
                                                                                       isLoading = false
                                                                                   }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                Video Generation History for {product?.name}
                <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" my={5}><CircularProgress /></Box>
                ) : historyGenerations.length === 0 ? (
                    <Typography>No video generations found for this product.</Typography>
                ) : (
                    <Box>
                        {historyGenerations.map((gen: VideoGeneration) => (
                            <Card key={gen.id} sx={{ mb: 2, cursor: 'pointer' }} onClick={() => onLoadGeneration(gen)}>
                                <CardContent>
                                    <Typography variant="h6">
                                        Generation #{gen.iteration_number || gen.id} - Status: <Chip label={gen.status} color={gen.status === 'completed' ? 'success' : 'warning'} />
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Created: {new Date(gen.created_at).toLocaleString()}
                                    </Typography>
                                    <Typography variant="body2">AI Service for Prompt: {gen.ai_service_used}</Typography>
                                    <Typography variant="body2">AI Service for Video: {gen.video_ai_service_used}</Typography>
                                    <Typography variant="body2">Total Cost: ${gen.total_cost?.toFixed(4)}</Typography>

                                    {gen.video_result_details?.video_url && (
                                        <Box mt={2}>
                                            <video
                                                src={gen.video_result_details.video_url}
                                                width="200"
                                                muted
                                                style={{ borderRadius: '8px' }}
                                            />
                                        </Box>
                                    )}
                                    <Button size="small" sx={{mt: 1}} onClick={(e) => { e.stopPropagation(); onLoadGeneration(gen); }}>
                                        Load this generation
                                    </Button>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default VideoGenerationHistoryDialog;
